<template>
  <div id='register'>
    <!-- <van-nav-bar title="注册" left-text="返回" left-arrow @click-left="Back"/> -->
    <van-form ref="formRef">
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
        新密码长度8-20位 包含数字和字母
      </van-notice-bar>
      <van-field
        v-model="form.phone"
        type="tel"
        label="手机号"
        placeholder="请填写手机号"
        name="phone"
        :rules="[
          { required: true, message: '请填写您的手机号码！' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}
        ]" />
      <!-- <van-field v-model="form.password" type="password" label="密码" placeholder="请填写密码" :rules="[{ required: true}]"/> -->
      <van-field
        v-model="form.password"
        type="password"
        label="密码"
        placeholder="请填写密码"
        :rules="[
          { required: true, message: '密码不能为空' },
          {
            pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,20}$/,
            message: '密码格式不符合'
          }
        ]"
      />
      <van-field v-model="form.password2" type="password" label="确认密码" placeholder="请填写确认密码" :rules="[{ required: true, message:form.msg_Repass}]"/>
      <van-field v-model="form.verify" type="digit" label="短信验证码" placeholder="请填写短信验证码" :rules="[{ required: true}]">
        <template #button>
          <van-button native-type="button" :disabled=form.Time size="small" type="primary" @click="getVertify(2)">
            <span v-show="!form.Time">发送验证码</span>
            <van-count-down ref="countDown" v-show="form.Time" time=60000 format="ss s后重新获取" @finish="changeDownCount" />
          </van-button>
        </template>
      </van-field>
      <div style="margin:10px auto 0; width: 80%;">
        <van-button block size="small" type="info" @click="subRegis">确定注册</van-button>
      </div>
      <div style=" text-align: center; color: gray;font-size:16px; margin-top: 5%;">关注公众号【中翔科技东莞有限公司】登入后台</div>
    </van-form>
  </div>
</template>

<script>
import { register, shareRegister } from '@/api/login.js'
import { smsVerify } from '@/api/user.js'
export default {
  data () {
    return {
      form: {
        phone: '',
        password: '',
        password2: '',
        vertify: '',
        msg_Repass: '',
        Time: false
      },
      userId: ''
    }
  },
  methods: {
    // Back () { this.$router.push('/login') },
    changeDownCount () {
      this.$refs.countDown.reset()
      this.form.Time = false // 关闭倒计时状态
    },
    getVertify () {
      // 重置发送验证码时间
      this.$refs.countDown.reset()
      this.$refs.formRef.validate('phone').then(async _ => {
        const { data: res } = await smsVerify({ account: this.form.phone })
        if (res.msg && res.msg.indexOf('登录账号已存在') !== -1) {
          this.$toast('登录账号已存在')
          this.changeDownCount()
          return
        }
        this.form.Time = true // 开始倒计时状态
      }).catch(value => {
        this.$toast.fail('请输入正确的手机号')
      })
    },
    subRegis () {
      if (!this.form.phone) return this.$toast.fail('请填写注册手机号')
      if (!this.form.password) return this.$toast.fail('请填写密码')
      if (!this.form.password2) return this.$toast.fail('请再次输入密码确认')
      if (!this.form.verify) return this.$toast.fail('请填写短信验证码')
      if (this.form.password !== this.form.password2) { // 如果确认密码出错，重写填写
        this.form.password2 = ''
        this.form.msg_Repass = '请填写正确的确认密码'
        return 0
      }
      this.userId = this.$route.query.mobile
      if (this.userId && this.userId !== '') {
        this.shareRegister()
      } else {
        this.register()
      }
      // 提交注册信息 成功后返回登录
    },
    // 注册接口
    async register () {
      const { data: res } = await register({ account: this.form.phone, password: this.form.password, code: this.form.verify })
      // if (res.code === 1 && res.msg.indexOf('验证码格式错误') !== -1) return this.$toast('验证码格式错误')
      // if (res.code === 1 && res.msg.indexOf('验证码已过期, 请重新点击发送') !== -1) return this.$toast('验证码已过期, 请重新点击发送')
      // if (res.code === 1 && res.msg.indexOf('验证码输入错误, 请重新输入') !== -1) return this.$toast('验证码输入错误, 请重新输入')
      if (res.code === 1) return this.$toast(res.msg)
      if (res.code === 0) {
        this.$toast.success('注册成功')
        this.$router.push('/login')
      }
    },
    // 分享注册接口
    async shareRegister () {
      const { data: res } = await shareRegister({ account: this.form.phone, password: this.form.password, mobile: this.$route.query.mobile, code: this.form.verify })
      if (res.code === 1 && res.msg.indexOf('验证码格式错误') !== -1) return this.$toast('验证码格式错误')
      if (res.code === 1 && res.msg.indexOf('验证码已过期, 请重新点击发送') !== -1) return this.$toast('验证码已过期, 请重新点击发送')
      if (res.code === 1 && res.msg.indexOf('验证码输入错误, 请重新输入') !== -1) return this.$toast('验证码输入错误, 请重新输入')
      if (res.code === 0) {
        this.$toast.success('注册成功')
        this.$router.push('/login')
      }
    }
  },
  beforeCreate () {},
  created () {
    console.log(this.$route.query.mobile)
  },
  mounted () {}
}
</script>

<style lang="less" scoped>

</style>
